import Vue from 'vue'
import Vuex from 'vuex'

import index from '@/views/index.vue'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // 头部和内容切换
    // tabs总数
    headTabNum: 1,
    // tabs已点内容
    headTabs: [{
      title: '首页',
      addNum: '1',
      content: 'index',
      url: 'index',
      close: false
    }],
    // 当前tab索引
    currentHeadTab: '1',
    // 按左侧 列表展示不同类型
    _status: '0',
    // 列表表格加载状态
    tableLoading: false,
    // 返回商品列表刷新
    updataList: false,
    // 返回订单列表刷新
    updataOrderList: false,
    // 返回装家福列表刷新
    updateActivityList: false,
    // 权限,所有菜单
    permission: {},
    // 权限
    roles: [],
    // 角色权限对应的按钮api
    rolesApi: [],

    // 新增员工，查询到的数据
    newStaff: {},
    // 编辑商品，存数据
    editGoods: '',
    //编辑案例,存数据
    editCase: '',
    // 当前用户有权访问的菜单
    userMenu: [],
    // 面包屑导航树
    breadroute: [{
      title: '首页',
      addNum: '1',
      content: 'index',
      url: 'index',
      close: false
    }],
    // 帮助中心显示隐藏
    helpDom: false,
    // 路由临时参数
    temQuery: {},
    // 临时处理订单tab切换
    orderCurrentTab: '',
    // 需要刷新的页面
    // 注意，这里如果是输入在slider可点击的页面（即面包屑一二级页面）的话，点两次会报错，因为还没做与上一次判断的比较
    refreshPages: [
      '添加商品',
      'add-goods',
      '发布活动',
      'release-activity',
      '添加员工',
      'staff-add',
      '编辑员工',
      'staff-edit',
      '查看员工',
      'staff-info',
      '员工列表',
      'staff-list',
      '产品服务管理',
      'product-server',
      '添加产品服务',
      'product-server-add',
      "添加案例",
      "case-add",
      "案例管理",
      "case-management",
      "编辑案例",
      "case-edit",
      "基础信息",
      "seller-baseinfo",
      "编辑商品",
      "edit-goods",
      "首页浏览数据",
      "watch-data",
      "product-pv-view",
      "coupons-view",
      "signup-view",
      "数据统计",
      "report",
      "编辑活动",
      "edit-activity",
      "装家福",
      "market-list",
      "新增优惠券",
      "add-coupons",
      "编辑优惠券",
      "edit-coupons",
      "优惠券列表",
      "coupons-list",
    ],
    //新增时候离开有提醒
    commitFlag:false,
    showLeave:false,
    leaveConfirm:false,
    tabTemp:{},
    sellerInfo:{},
  },
  mutations: {
    // 头部和内容切换
    addHeadTab(state, obj) {
      state.headTabs = obj.headTabs
      // sessionStorage.setItem("headTabs", JSON.stringify(store.state.headTabs))
      // sessionStorage.setItem("headTabsValue", JSON.stringify(store.state.headTabsValue))
    },
    //只有清空头部使用
    setHeadTabsClear(state, val) {
      state.headTabs = val
      state.headTabNum = 1;
    },
    setHeadTabs(state, val) {
      state.headTabs = val
    },
    setHeadTabNum(state, val) {
      state.headTabNum = val
    },
    setCurrentHeadTab(state, val) {
      state.currentHeadTab = val
    },
    // 订单列表按左侧不同类型
    set_Status(state, val) {
      state._status = val
    },

    // 列表表格加载状态
    setTableLoading(state, val) {
      state.tableLoading = val
    },
    // 返回商品列表自动刷新
    setUpdataList(state, val) {
      state.updataList = val
    },
    // 返回装家福自动刷新
    setActivityList(state, val) {
      state.updateActivityList = val
    },
    // 返回订单列表自动刷新
    setUpdataOrderList(state, val) {
      state.updataOrderList = val
    },
    // 获取所有权限菜单树
    setPermission(state, val) {
      state.permission = val
    },
    // 权限,角色权限对应上面的菜单显示
    setRoles(state, val) {
      state.roles = val
    },
    // 角色权限对应上面的菜单显示
    setRolesApi(state, val) {
      state.rolesApi = val
    },
    // 新增员工，查询到的数据
    setNewStaff(state, val) {
      state.newStaff = val
    },
    setEditGoods(state, val) {
      state.editGoods = val
    },
    setEditCases(state, val) {
      state.editCase = val;
    },
    // 同步当前用户有权访问的菜单
    setUserMenu(state, val) {
      state.userMenu = val
    },
    // 同步面包屑
    setBreadroute(state, val) {
      state.breadroute = val
    },
    // 页面传递参数
    temQuery(state, val) {
      state.temQuery = val
    },
    // 订单tabs临时处理
    changeCurrentTab(state, val) {
      state.orderCurrentTab = val
    },
    //设置页面切换时候需要弹是否离开
    setCommitFlag(state, val){
      state.commitFlag = val;
    },
    //显示离开弹窗
    setShowLeave(state,val){
      state.showLeave = val;
    },
    //暂存切换要去的地方
    setTabTemp(state,val){
      state.tabTemp = val;
    },
    setLeaveConfirm(state,val){
      state.leaveConfirm = val;
    },
    setSellerInfo(state,val){
      state.sellerInfo = val;
    }
  },
  actions: {
    // 头部和内容切换
    addHeadTab(context, obj) {
      if(this.state.commitFlag){
        context.commit('setTabTemp', obj)
        context.commit('setShowLeave',true);
        return;
      }else{
        context.commit('setShowLeave',false);
      }
      let lastClick = sessionStorage.getItem('lastClick')
      if (lastClick == obj.addTitle) {
        return false
      } else {
        sessionStorage.setItem('lastClick', obj.addTitle)
      }
      let has = this.state.headTabs.some(({
        title
      }) => title == obj.addTitle)
      let arr = this.state.headTabs;
      let lastTab = arr[arr.length - 1]
      let lastTabNeedRfs = this.state.refreshPages.some((i) => {
        return lastTab.title == i || lastTab.url == i
      })

      if (!has) {
        let name = obj.addTitle
        let url = obj.addUrl
        let newTabNum = parseInt(this.state.headTabNum) + 1
        let currentIndex = newTabNum
        // let currentComponent = () => import(`../views/${url}.vue`)
        // require替代import：懒加载/按需加载
        let currentComponent = resolve => require([`../views/${url}.vue`], resolve)

        if (lastTabNeedRfs) {
          arr.pop()
          newTabNum -= 1
          currentIndex -= 1
        }

        arr.push({
          title: name,
          addNum: newTabNum.toString(),
          content: currentComponent,
          url: url,
          close: true
        })

        context.commit('addHeadTab', {
          headTabs: arr
        })
        context.commit('setHeadTabNum', currentIndex)
        context.commit('setCurrentHeadTab', currentIndex.toString())
      }
      // 已缓存页面
      else {
        let currentTab =
          this.state.headTabs.find(
            (item, index, arr) => item.title == obj.addTitle
          )

        if (lastTabNeedRfs) {
          let newTabNum = parseInt(this.state.headTabNum)
          arr.pop()
          newTabNum -= 1
          context.commit('addHeadTab', {
            headTabs: arr
          })
          context.commit('setHeadTabNum', newTabNum)
        }

        context.commit('setCurrentHeadTab', currentTab.addNum.toString())

      }
      // 面包屑导航
      context.dispatch('setBreadroute', {
        title: obj.addTitle,
        url: obj.addUrl
      })
      // 路由传参数
      obj.query ? context.commit('temQuery', obj.query) : ''
    },
    removeHeadTabo(context, tabIndex) {
      // console.log(sessionStorage.getItem('refreshIndex'))
      let newArr, prevIndex, tabNum
      tabNum = this.state.headTabNum - 1
      // 当前页面删除
      if (tabIndex == this.state.currentHeadTab) {
        let nowIndex = this.state.headTabs.findIndex(
          (item, index, arr) => item.addNum == tabIndex
        )
        prevIndex = this.state.headTabs[nowIndex - 1].addNum;
        newArr = this.state.headTabs.filter(item => item.addNum !== tabIndex)
        context.commit('setHeadTabs', newArr)
        context.commit('setCurrentHeadTab', prevIndex.toString())
      }
      // 非当前页面删除
      // 从需要刷新的页面跳转到1.已有页面√ ；2.新增页面 =>暂时无法在本action里debug，因为删除的同时又增加（addHeadTab），都是异步action操作
      else {
        newArr = this.state.headTabs.filter(item => item.addNum !== tabIndex)
        context.commit('setHeadTabs', newArr)
      }
      context.commit('setHeadTabNum', tabNum)
    },
    //只有清空头部标签使用
    setHeadTabs(context, arr) {
      context.commit('setHeadTabsClear', arr)
      context.commit('setCurrentHeadTab', arr[0].addNum)
    },
    // 只留一个
    setHeadTabs2(context, arr) {
      let url = arr[0].content
      let currentComponent = resolve => require([`../views/${url}.vue`], resolve)
      arr = [{
        title: arr[0].title,
        addNum: arr[0].addNum,
        content: currentComponent,
        url: arr[0].url,
        close: true
      }]
      context.commit('setHeadTabsClear', arr)
      context.commit('setCurrentHeadTab', arr[0].addNum)
    },
    setCurrentHeadTab(context, current) {
      let currentTab = this.state.headTabs.find(
        (tab, index, arr) => tab.title == current.label
      )
      context.commit('setCurrentHeadTab', currentTab.addNum.toString())
    },

    // 订单列表按左侧不同类型
    set_Status(context, val) {
      context.commit('set_Status', val)
    },
    // 列表表格加载状态
    setTableLoading(context, val) {
      context.commit('setTableLoading', val)
    },
    // 返回列表自动刷新
    setUpdataList(context, val) {
      context.commit('setUpdataList', val)
    },
    // 返回订单列表自动刷新
    setUpdataOrderList(context, val) {
      context.commit('setUpdataOrderList', val)
    },
    // 返回装家福列表自动刷新
    setActivityList(context, val) {
      context.commit('setActivityList', val);
    },
    // 获取所有权限菜单树
    setPermission(context, val) {
      context.commit('setPermission', val)
    },
    // 权限
    setRoles(context, val) {
      context.commit('setRoles', val)
    },
    // 角色权限对应上面的菜单显示
    setRolesApi(context, val) {
      context.commit('setRolesApi', val)
    },
    // 新增员工，查询到的数据
    setNewStaff(context, val) {
      context.commit('setNewStaff', val)
    },
    // 编辑商品
    setEditGoods(context, val) {
      context.commit('setEditGoods', val)
    },
    //编辑案例
    setEditCases(context,val){
      context.commit('setEditCases', val)
    },
    // 订单tabs临时处理
    changeCurrentTab(context, val) {
      context.commit('changeCurrentTab', val)
    },
    //设置页面切换时候需要弹是否离开
    setCommitFlag(context,val){
      context.commit('setCommitFlag', val)
    },
    setShowLeave(context,val){
      context.commit('setShowLeave',val)
    },
    setTabTemp(context,val){
      context.commit('setTabTemp',val)
    },
    setLeaveConfirm(context,val){
      context.commit('setLeaveConfirm',val);
    },
    setSellerInfo(context,val){
      context.commit('setSellerInfo',val);
    },
    // 调起当前用户有权访问的菜单
    setUserMenu(context, val) {
      let arr = []
      let breadarr = []
      for (let i = 0; i < val.length; i++) {
        if (val[i].children) {
          for (var j = 0; j < val[i].children.length; j++) {
            arr.push([val[i], val[i].children[j]])
          }
        } else {
          arr.push([val[i]])
        }
      }
      context.commit('setUserMenu', arr)
    },
    setBreadroute(context, obj) {
      let tempMenu = [
        'release-activity' // 发布活动
      ];
      let arr = []
      let oriArr = this.state.breadroute
      let backArr = JSON.parse(JSON.stringify(this.state.userMenu))
      let name = obj.title
      // 临时菜单无需保存
      if (tempMenu.indexOf(obj.url) != -1) {
        return;
      }
      for (var i = 0; i < backArr.length; i++) {
        if (backArr[i][backArr[i].length - 1].uri == obj.url) {
          arr = backArr[i]
          break
        }
      }
      // 当选中的组件不在后台返回的数据树里时
      if (arr.length == 0) {
        oriArr.push(obj)
        arr = oriArr
      }
      context.commit('setBreadroute', arr)
    }
  },
  // gettes是对同时需要操作多个状态时的场景的需求的实现，即全部同步归位后的计算
  getters: {
    getHeadTabs(state) {
      return state.headTabs
    },
    getCurrentHeadTab(state) {
      return state.currentHeadTab.toString()
    },
    getHeadTabNum(state) {
      return state.headTabNum
    },
    getCurrentTab(state) {
      return state.headTabs[state.currentHeadTab - 1]
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js